import { getProcessEnv } from "~utils/getProcessEnv";

export type CriteriaType =
    | "env:local"
    | "env:staging"
    | "env:production"
    | "env:green"
    | "env:blue"
    | "env:yellow"
    | "env:orange"
    | "env:purple"
    | "env:test"
    | "env:nav"
    | "env:nonProduction"
    | "env:nonStaging"
    | "env:all";

export interface CriteriaObject {
    id: CriteriaType;
    check(): boolean;
}

// for testability
export const getColorEnv = () => getProcessEnv().NEXT_PUBLIC_COLOR_ENV;

const criteriaList: CriteriaObject[] = [
    {
        id: "env:local",
        check: () => getColorEnv() === "development",
    },
    {
        id: "env:staging",
        check: () =>
            ["development", "staging"].includes(getColorEnv() as string),
    },
    {
        id: "env:production",
        check: () => true,
    },
    {
        id: "env:green",
        check: () => getColorEnv() === "green",
    },
    {
        id: "env:blue",
        check: () => getColorEnv() === "blue",
    },
    {
        id: "env:yellow",
        check: () => getColorEnv() === "yellow",
    },
    {
        id: "env:orange",
        check: () => getColorEnv() === "orange",
    },
    {
        id: "env:purple",
        check: () => getColorEnv() === "purple",
    },
    {
        id: "env:test",
        check: () => getColorEnv() === "test",
    },
    {
        id: "env:nonProduction",
        check: () => getColorEnv() !== "production",
    },
    {
        id: "env:nonStaging",
        check: () =>
            getColorEnv() !== "production" && getColorEnv() !== "orange",
    },
    {
        id: "env:all",
        check: () => true,
    },
];

export default criteriaList;
